module.exports = __webpack_public_path__ + "img/BillerEN.081467d8.png";